import React from 'react';

import Layout from 'components/layout/Layout';
import Container from 'components/container/Container';
import { TextWrapper, Title, Subtitle, OrderedList, OrderedListHeading, OrderedListItem, Seperator } from 'components/typography/Typography';
import SEO from 'components/SEO/SEO';

export default function PrivacyPolicyPage() {
  return (
    <Layout>
      <SEO
        title="Privacy Policy | Lyons Therapy"
        meta={[
          {
            name: 'robots',
            content: 'noindex'
          }
        ]}
      />
      <Container>
          <TextWrapper>
            <Title>
              Privacy Policy
            </Title>
            <Subtitle>
              How your data is used
            </Subtitle>
            <Seperator isBold={true} />
            <OrderedList>
              <OrderedListHeading>
                Introduction
              </OrderedListHeading>
              <OrderedListItem>
                I am committed to safeguarding the privacy of my website users and my clients.
              </OrderedListItem>
              <OrderedListItem>
                This policy applies when I am acting as a data controller with respect to the personal data of such persons; in other words, where I determine the purposes and means of the processing of that personal data.
              </OrderedListItem>
              <OrderedListItem>
                In this policy, "I", "me" and "my" refers to Toby Lyons.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Credit
              </OrderedListHeading>
              <OrderedListItem>
                This document was created using a template from Docular (https://seqlegal.com/free-legal-documents/privacy-policy).
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                The personal data that we collect
              </OrderedListHeading>
              <OrderedListItem>
                In this Section 3 I have set out the general categories of personal data that I process.
              </OrderedListItem>
              <OrderedListItem>
                Contact/Communication Data: I may process data enabling me to get in touch with you. The contact data may include your name, email address, telephone number, or postal address. The source of the contact data is from you filling out the enquiry form that goes through to a GDPR compliant email account or a work telephone.
              </OrderedListItem>
              <OrderedListItem>
                Personal/Sensitive Data: Prior to our first session I will ask you to fill out a brief questionnaire so that I will have the following on file: Name, Email, Contact Number, Emergency Contact Number, GP details. Though I often work without client notes, there may be certain circumstances that would necessitate the taking down of some. All the above information will be stored securely for 7 years and then destroyed.
              </OrderedListItem>
              <OrderedListItem>
                Transaction Data: If you chose to pay me via BACS then your details will appear on my bank statements.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Purposes of processing and legal bases
              </OrderedListHeading>
              <OrderedListItem>
                In this Section 4, I have set out the purposes for which I may process personal data and the legal bases of the processing.
              </OrderedListItem>
              <OrderedListItem>
                Operations - I may process your personal data for the purposes of operating my website, the processing and fulfilment of orders, providing my services, generating invoices, bills and other payment-related documentation. The legal basis for this processing is my legitimate interests, namely the proper administration of my website, services, and business and should we work together, the performance of a contract between you and me and/or taking steps, at your request, to enter into such a contract (Client-Therapist Agreement).
              </OrderedListItem>
              <OrderedListItem>
                Relationships and communications – I may process Contact data, Communication data, Personal data, Sensitive data and Transaction data for the purposes of managing my relationships, communicating with you (excluding communicating for the purposes of direct marketing) by email, SMS, and/or telephone, providing support services and complaint handling. The legal basis for this processing is my legitimate interests, namely communications with my website visitors, service users, individual customers and customer personnel, the maintenance of relationships, and the proper administration of my website, services, and business.
              </OrderedListItem>
              <OrderedListItem>
                Research and analysis – I may process usage data and/or transaction data for the purposes of researching and analysing the use of my website and services, as well as researching and analysing other interactions with my business. The legal basis for this processing is our legitimate interests, namely monitoring, supporting, improving and securing my website, services and business generally.
              </OrderedListItem>
              <OrderedListItem>
                Record keeping - I may process your personal data for the purposes of creating and maintaining my databases, back-up copies of my databases and my business records generally. The legal basis for this processing is my legitimate interests, namely ensuring that I have access to all the information I need to run my business properly and efficiently in accordance with this policy.
              </OrderedListItem>
              <OrderedListItem>
                Security - I may process your personal data for the purposes of security and the prevention of fraud and other criminal activity. The legal basis of this processing is my legitimate interests, namely the protection of my website, services and business, and the protection of others.
              </OrderedListItem>
              <OrderedListItem>
                Insurance and risk management – I may process your personal data where necessary for the purposes of obtaining or maintaining insurance coverage, managing risks and/or obtaining professional advice. The legal basis for this processing is my legitimate interests, namely the proper protection for my business, myself and my clients against risks.
              </OrderedListItem>
              <OrderedListItem>
                Legal claims – I may process your personal data where necessary for the establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure. The legal basis for this processing is my legitimate interests, namely the protection and assertion of my legal rights, your legal rights and the legal rights of others.
              </OrderedListItem>
              <OrderedListItem>
                Legal compliance and vital interests – I may also process your personal data where such processing is necessary for compliance with a legal obligation to which I am subject or in order to protect your vital interests or the vital interests of another natural person.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Your personal data and information
              </OrderedListHeading>
              <OrderedListItem>
                Sharing your personal data to others I will not disclose any personal data about my clients unless I determine there to be a legitimate risk to yourself or others, or if I am obligated to do so in accordance with the law. In the above situation I would endeavor to discuss this with a client prior to the disclosure of their personal data, but should I deem it necessary, I reserve the right to not do so.
              </OrderedListItem>
              <OrderedListItem>
                I, like all members of the BACP, have a clinical supervisor that I consult with for professional advice, guidance, and support. In these sessions there will be no personal data shared, nor anything identifiable or traceable to an individual client.
              </OrderedListItem>
              <OrderedListItem>
                Your site usage data may be stored on the servers of our hosting services providers (https://www.bluehost.com/)
              </OrderedListItem>
              <OrderedListItem>
                Financial transactions relating to my website and services may be handled by my payment services providers. I will share transaction data with my payment services providers only to the extent necessary for the purposes of processing your payments.
              </OrderedListItem>
              <OrderedListItem>
                In addition to the specific disclosures of personal data set out in this Section 5, though I hold all client information and discussions in the work in strict confidence, I may disclose your personal data where such disclosure is necessary for compliance with a legal obligation to which I am subject, or in order to protect your vital interests or the vital interests of another natural person. I may also disclose your personal data where such disclosure is necessary for the establishment, exercise, or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Retaining and deleting personal data
              </OrderedListHeading>
              <OrderedListItem>
                This Section 6 sets out my data retention policies and procedures, which are designed to help ensure that I comply with my legal obligations in relation to the retention and deletion of personal data.
              </OrderedListItem>
              <OrderedListItem>
                Personal data that I process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.
              </OrderedListItem>
              <OrderedListItem>
                We will retain your personal data as follows:
                (a)	Contact/Personal data will be retained for as long as it is necessary. After our work is finished it will be stored for a period of 6 years before being deleted annually.
                (b)	Sensitive Data will be stored separately from Personal data. After our work is finished the data will be stored securely for a period of 6 years before being deleted annually.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Your rights
              </OrderedListHeading>
              <OrderedListItem>
                In this Section 7, we have listed the rights that you have under data protection law.
              </OrderedListItem>
              <OrderedListItem>
                Your principal rights under data protection law are:
                (a)	the right to access - you can ask for copies of your personal data;
                (b)	the right to rectification - you can ask us to rectify inaccurate personal data and to complete incomplete personal data;
              </OrderedListItem>
              <OrderedListItem>
                These rights are subject to certain limitations and exceptions. You can learn more about the rights of data subjects by visiting https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/.
              </OrderedListItem>
              <OrderedListItem>
                You may exercise any of your rights in relation to your personal data by contacting me through the online enquiry form. You also have the right to log a complaint with the ICO should you feel your data has been improperly handled.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Managing cookies
              </OrderedListHeading>
              <OrderedListItem>
                This website does not store cookies.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Amendments
              </OrderedListHeading>
              <OrderedListItem>
                We may update this policy from time to time by publishing a new version on our website.                
              </OrderedListItem>
              <OrderedListItem>
                You should check this page occasionally to ensure you are happy with any changes to this policy.
              </OrderedListItem>
              <Seperator />
              <OrderedListHeading>
                Our details
              </OrderedListHeading>
              <OrderedListItem>
                This website is owned and operated by Toby Lyons                
              </OrderedListItem>
              <OrderedListItem>
                You can contact me by email at toby@lyonstherapy.co.uk
              </OrderedListItem>
            </OrderedList>
          </TextWrapper>
        </Container>
    </Layout>
  );
} 